import React, { useMemo } from 'react'
import { withStyles } from '@material-ui/core/styles'
import {
  Typography,
  Button,
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
} from '@material-ui/core'
import DescriptionIcon from '@material-ui/icons/Description'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import styles from './styles'

const formatSize = bytes => {
  if (!bytes || bytes === 0) return '0 KB'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i]
}

const FilePicker = ({
  classes,
  files = [],
  selectedFiles = [],
  onSelectionChange,
  onConfirm,
  onBack,
}) => {
  const isAllSelected = files.length > 0 && selectedFiles.length === files.length
  const isSomeSelected = selectedFiles.length > 0 && selectedFiles.length < files.length

  const handleToggleFile = file => {
    const isSelected = selectedFiles.some(f => f.id === file.id)
    if (isSelected) {
      onSelectionChange(selectedFiles.filter(f => f.id !== file.id))
    } else {
      onSelectionChange([...selectedFiles, file])
    }
  }

  const handleToggleAll = () => {
    if (isAllSelected) {
      onSelectionChange([])
    } else {
      onSelectionChange(files)
    }
  }

  return (
    <div className={classes.root}>
      <div>
        <div className={classes.header}>
          <div>
            <Typography className={classes.title}>Select PDFs to Process</Typography>
            <Typography className={classes.subtitle}>
              {selectedFiles.length} of {files.length} files selected
            </Typography>
          </div>
        </div>
      </div>

      <div className={classes.fileListContainer}>
        <div className={classes.fileListHeader}>
          <FormControlLabel
            control={
              <Checkbox
                className={classes.checkbox}
                checked={isAllSelected}
                indeterminate={isSomeSelected}
                onChange={handleToggleAll}
              />
            }
            label={
              <Typography style={{ fontSize: '14px', fontWeight: 600, color: '#475569' }}>
                Select All
              </Typography>
            }
          />
        </div>

        <div className={classes.fileList}>
          {files.map(file => {
            const isSelected = selectedFiles.some(f => f.id === file.id)
            return (
              <div
                key={file.id}
                className={classes.fileItem}
                onClick={() => handleToggleFile(file)}
              >
                <Checkbox
                  className={classes.checkbox}
                  checked={isSelected}
                  onClick={e => e.stopPropagation()}
                  onChange={() => handleToggleFile(file)}
                />
                <DescriptionIcon className={classes.fileIcon} />
                <span className={classes.fileName}>{file.name}</span>
                <span className={classes.fileSize}>{formatSize(file.size)}</span>
              </div>
            )
          })}
        </div>
      </div>

      <div className={classes.footer}>
        <Button
          startIcon={<ArrowBackIcon />}
          className={classes.backButton}
          onClick={onBack}
        >
          Back to Folders
        </Button>

        <Button
          variant="contained"
          color="primary"
          className={classes.processButton}
          disabled={selectedFiles.length === 0}
          onClick={() => onConfirm(selectedFiles)}
        >
          Process Selected ({selectedFiles.length})
        </Button>
      </div>
    </div>
  )
}

export default withStyles(styles)(FilePicker)
